import { OUTBOUND_CAMPAIGN } from "../../../constants/reducer_names";
import { createSlice } from "@reduxjs/toolkit";

const initialState = {

    autoAnswer: 0,
    incomingCallInfo: {} as any,
    userCallInfo: 0,
    campaignPopup: false,
    popupData: {} as any
}
const outboundCampaignSlice: any = createSlice({
    name: OUTBOUND_CAMPAIGN,
    initialState,
    reducers: {

        setAutoAnswer: (state, { payload }) => {
            state.autoAnswer = payload ?? 0
        },
        setincomingCallInfo: (state, { payload }) => {
            state.incomingCallInfo = payload
        },
        setUserCallInfo: (state, { payload }) => {
            state.userCallInfo = payload
        },
        clearIncomingCallInfo: (state) => {
            state.incomingCallInfo = {}
        },
        outboundCampaignPop: (state, { payload }) => {
            state.popupData = payload
            state.campaignPopup = true
        },
        outboundCampaignclose: (state) => {
            state.popupData = {}
            state.campaignPopup = false
        }
    }
})
export const outboundCampaignSliceAction = outboundCampaignSlice.actions;
export default outboundCampaignSlice.reducer
